import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';

import ShareEmailForm from './ShareEmailForm';
import ShareSocialNetworksNavigation from './ShareSocialNetworksNavigation';

const styles = theme => ({
  form: {
    padding: '16px 0 16px',
  },
  typographySeparator: {
    position: 'relative',
    color: theme.palette.primary.A100,
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: '50%',
      left: 0,
      right: 'calc(50% + 24px)',
      height: 1,
      backgroundColor: theme.palette.primary.A100,
      pointerEvents: 'none',
    },
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: '50%',
      right: 0,
      left: 'calc(50% + 24px)',
      height: 1,
      backgroundColor: theme.palette.primary.A100,
      pointerEvents: 'none',
    },
  },
  navigation: {
    padding: '16px 16px 56px',
  },
});

const ShareDialog = ({ open, onClose, actions, submitting, classes }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle>
      <Typography
        variant="title"
        align="center"
      >
        Spread the Word
      </Typography>
    </DialogTitle>
    <DialogContent>
      <ShareEmailForm
        form="shareForm"
        className={classes.form}
        onSubmitSuccess={onClose}
        variant="dialog"
      />
      <Typography
        className={classes.typographySeparator}
        variant="subheading"
        color="secondary"
        align="center"
      >
        or
      </Typography>
      <ShareSocialNetworksNavigation
        className={classes.navigation}
        onShareButtonClick={onClose}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => actions.submit('shareForm')}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        Send
      </Button>
    </DialogActions>
  </Dialog>
);

ShareDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
    typographySeparator: PropTypes.string.isRequired,
    navigation: PropTypes.string.isRequired,
  }).isRequired,
};

ShareDialog.defaultProps = {
  open: false,
  onClose: () => {},
};

const mapStateToProps = store => ({
  submitting: isSubmitting('shareForm')(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ShareDialog),
);



// WEBPACK FOOTER //
// ./src/components/common/ShareDialog/ShareDialog.js